import { useState } from "react";
import Select from "react-select";
import { usePermisions } from "../../../hooks/usePermisions";

export default function GruposSubgrupos({
  caractFiltro,
  handleChange,
  nombreCombo,
  tipoConsulta,
  tipofiltroSubGruposFiltrada,
  datosEditar,
  idComponente = 0,
}) {
  const { permissions, infoUser } = usePermisions(idComponente);
  function mostrarSelect() {
    const dataG = permissions.superAdmin
      ? caractFiltro.resultGruposSubGruposSuperAdmin
      : caractFiltro.resultGruposSubGrupos;
    if (tipoConsulta === "1") {
      return (
        <Select
          value={datosEditar}
          key={`${nombreCombo}-${dataG.length}`}
          isMulti
          name={nombreCombo}
          options={dataG.map((e, i) => {
            return { value: e.id_grupo, label: e.nombre };
          })}
          classNamePrefix="select"
          onChange={(e) => {
            //let arrayValores = e.map((val) => val.value);
            handleChange({ nombreCombo, valor: e, tipo: "1" });
          }}
          placeholder="Seleccione..."
        />
      );
    } else {
      return (
        <Select
          value={datosEditar}
          key={`${nombreCombo}-${tipofiltroSubGruposFiltrada.length}`}
          isMulti
          name={nombreCombo}
          options={tipofiltroSubGruposFiltrada?.map((e, i) => {
            return {
              value: e.id_grupo,
              label: e.nombre,
              value_parent: e.id_grupo_padre,
            };
          })}
          classNamePrefix="select"
          placeholder="Seleccione..."
          onChange={(e) => {
            //let arrayValores = e.map((val) => val.value);
            handleChange({ nombreCombo, valor: e, tipo: "2" });
          }}
        />
      );
    }
  }
  return <>{mostrarSelect()}</>;
}
